import React, { Fragment } from 'react'
import { useMemo } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'

import Text from 'components/_new/typography/Text/Text'
import { Box } from 'components/_new/layout'

import Link from '../Link/Link'

import messages from './messages'


const GenderLinks: React.FunctionComponent = () => {
  const { pathname, gender } = useConnect({
    pathname: 'view.seoPage.pathname',
    gender: 'view.seoPage.gender',
  })

  const links = useMemo(() => {
    const slugByPathname = {
      '/perfumes': 'perfumes',
      '/colognes': 'colognes',
      '/fragrance': 'fragrance',
    }

    const slug = slugByPathname[pathname] || gender === 'female' ? 'perfumes' : 'colognes'

    return [
      {
        title: { ...messages.linkTitle.male, values: { slug } },
        to: `/${slug}-for-women`,
      },
      {
        title: { ...messages.linkTitle.male, values: { slug } },
        to: `/${slug}-for-men`,
      },
    ]
  }, [ gender, pathname ])

  return (
    <Fragment>
      <Text
        message={messages.gender}
        size="14-16"
        color="gray-50"
        uppercase
      />
      <Box mt={16}>
        {
          links.map(({ title, to }, index) => (
            <Link key={index} to={to}>
              <Text
                message={title}
                size="12-24"
                color="black"
                capitalize
              />
            </Link>
          ))
        }
      </Box>
    </Fragment>
  )
}


export default GenderLinks
